<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Area code (e.g. +86)" prop="areaCode" >
        <a-input v-model="form.areaCode" placeholder="Enter area code (e.g. +86)" />
      </a-form-model-item>
      <a-form-model-item label="Country name" prop="country" >
        <a-input v-model="form.country" placeholder="Enter country name (Arabic)" />
      </a-form-model-item>


      <a-form-model-item label="Country name (English)" prop="countryEn" >
        <a-input v-model="form.countryEn" placeholder="Enter country name in English" />
      </a-form-model-item>



      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMobileCode, addMobileCode, updateMobileCode } from '@/api/mobileCode/mobileCode'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        areaCode: null,

        country: null,
        countryEn: null,
        countryCn: null,
        countryBm: null,
        countryIn: null,

        isOpen: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        areaCode: [
          {required: true, message: 'Area code is required', trigger: 'blur'}
        ],

        country: [
          {required: true, message: 'Country name is required', trigger: 'blur'}
        ]
        ,
        countryEn: [
          {required: true, message: 'English country name is required', trigger: 'blur'}
        ]
        ,
        countryCn: [
          {required: true, message: 'French country name is required', trigger: 'blur'}
        ]
        ,
        countryBm: [
          {required: true, message: 'Spanish country name is required', trigger: 'blur'}
        ]
        ,
        countryIn: [
          {required: true, message: 'Japanese country name is required', trigger: 'blur'}
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        areaCode: null,
        country: null,
        countryEn: null,
        countryCn: null,
        countryBm: null,
        countryIn: null,
        isOpen: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMobileCode({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMobileCode(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMobileCode(this.form).then(response => {
              this.$message.success(
                'Created successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
